<template>
	<div class="info-box" v-if='isShow'>
		<div class="mask"></div>
		<div class="content">
			<p class="titles">
				<span class="t_title">{{title}}</span>
				<img @click="$emit('closeDialog')" :src="closeImg" class="closeImage" />
			</p>
			
			<div class="body">
				<template v-for="(column,r) in infoColumns">
					<div v-if="column.key == 'memo'" class="memo">
						<span class="name">{{ column.name }}</span>
						<span class="value">{{getLabel(column,r)}}</span>
					</div>
					<div v-else class="item" :key="r" :class="[r % 2 == 0 ? 'left' : 'right']">
						<span class="name">{{ column.name }}</span>
						<span class="value">{{getLabel(column,r)}}</span>
					</div>
				</template>
			</div>
			
			<div class="button"><button @click="$emit('closeDialog')">确定</button></div>
		</div>
	</div>
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	
	export default {
		// name: "infoDialog",
		data() {
			return {
				// isShow: false,
				closeImg: resourcesStore.getters.getResourcesByName('wedoButton/close.png'),
				infoColumns: [
					{
						name: "单位名称",
						key: "name"
					}, {
						name: "负责人",
						key: "leader",
					}, {
						name: "联系方式",
						key: "phoneNum"
					}, {
						name: "地址",
						key: "address"
					}, {
						name: "配电房数量",
						key: "roomCount",
					},{
						name: "变压器数量",
						key: "levelName"
					}, {
						name: "变压器总容量",
						key: "transformerCount"
					}, {
						name: "负荷容量",
						key: "loadCapacity",
					}, {
						name: "备注",
						key: "memo",
					}
				]
			}
		},
		props: {
			isShow: {
				type: Boolean,
				default: false
			},
			title: {
				type: String,
				default: undefined
			},
			nowUnit: {
				type: Object,
				default () {
					return {}
				}
			},
		},
		computed: {
			getLabel() {
				return (column, columnIndex)=>{
					//获取第l行第r格的内容
					if (this.nowUnit == undefined) {
						return ''
					}
					
					var	data = this.nowUnit[column.key]
					
					if (data == undefined) {
						return ''
					}
					
					return data
				}
			}
		},
		methods: {
			// close() {
			// 	this.isShow = false
			// },
			// openInfoDialog(title, data, infoColumns) {
			// 	this.nowUnit = data
			// 	this.title = title
			// 	this.infoColumns = infoColumns
			// 	this.isShow = true
			// 	this.closeImg = resourcesStore.getters.getResourcesByName('wedoButton/close.png')
			// },
		}
	}
</script>

<style>
	.info-box{
		position: absolute;
		width: auto;
		height: auto;
	}
	
	.info-box .mask {
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5);
		position: fixed;
		left: 0;
		top: 0;
		z-index: 99;
	}
	
	.info-box .content {
		z-index: 999;
		position: fixed;
		top: 0%;
		left: 0;
		right: 0;
		margin: auto;
		width: 6rem;
		padding: 0;
		background-color: rgb(42,88,200);
		border-radius: .06rem;
		color: white;
		margin-top: .7rem;
		text-align: left;
		padding: 0.2rem;
		height: 62%;
		opacity: 0.9;
	}
	
	.info-box .content .titles {
		color: white;
		margin-bottom: .15rem;
		font-weight: 1000;
		height: 20px;
	}
	
	.info-box .content .t_title {
		float: left;
		color: white;
		font-size: .18rem;
		font-weight: 400;
	}
	
	.info-box .content .closeImage {
		float: right;
		width: .2rem;
		height: .2rem;
		cursor: pointer;
	}
	
	.info-box .content .body .item{
		width: 48%;
		padding: .1rem 0;
		display: flex;
	}
	.info-box .content .body .memo{
		width: 100%;
		padding: .1rem 0;
		display: flex;
	}
	.info-box .content .body .left{
		float: left;
	}
	.info-box .content .body .right{
		float: right;
	}
	.info-box .content .body span{
		color: white;
		padding: .05rem;
	}
	
	.info-box .content .body .name{
		width: 35%;
		height: .18rem;
	}
	.info-box .content .body .value{
		border: 1px solid #D6D6D6;
		border-radius: 0.05rem;
		width: 65%;
		height: .18rem;
	}
	
	.info-box .content .body .memo .name{
		width: 15.65%;
	}
	
	.info-box .content .body .memo .value{
		width: 84.35%;
		height: 1rem;
		padding: 0;
		margin: 0;
		text-indent: .05rem;
	}
	
	.info-box .content .button{
		width: 100%;
		text-align: center;
	}
	.info-box .content .button button{
		padding: .02rem .15rem;
		background-color: rgb(64,127,255);
		color: white;
		border-radius: 0.1rem;
		margin-top: .1rem;
	}
</style>
